import { render } from "./CompetitorInventoryStatus.vue?vue&type=template&id=0cc2e0c0&scoped=true"
import script from "./CompetitorInventoryStatus.vue?vue&type=script&lang=js"
export * from "./CompetitorInventoryStatus.vue?vue&type=script&lang=js"

import "./CompetitorInventoryStatus.vue?vue&type=style&index=0&id=0cc2e0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc2e0c0"]])

export default __exports__